import { PureComponent, Component, createRef } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import thousands from 'thousands';
import InputGroup from 'reactstrap/lib/InputGroup';
import InputGroupAddon from 'reactstrap/lib/InputGroupAddon';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Formik } from 'formik';

import {
  Segment,
  Grid,
  Input,
  Search,
  Icon,
  Button,
  Form,
  Modal,
  Divider,
  Dropdown,
} from 'semantic-ui-react';

import Label from 'reactstrap/lib/Label';
import { debounce, get, isEmpty, find } from '../../../../utils/lodash';

import {
  activityInviteTypeValidation,
  initialValues,
} from '../../../../validations/activityInviteValidation';

import {
  ContractorCreate,
  VenueCreate,
  VenueUpdate,
  ContractorUpdate,
} from '../../../organization/forms';

import { RESTRICTION_TYPES, permissionTypes } from '../../../../utils/constant';

import {
  CustomTextArea,
  UserPermissionsInput,
} from '../../../../components/form';

import {
  getOrgVenues,
  getVenueTypes,
  getOrgVenuesTypes,
  getOccupationTypes,
  getOccupation,
  getOrgContractors,
  createOrgContractor,
  updateOrgContractor,
  createOrgVenues,
  updateOrgVenues,
  assignProjectVenue,
  assignProjectContractor,
  updateProjectInputs,
  setActivityState,
  deleteProjectVenue,
  updateProjectVenueCost,
  deleteProjectContractor,
  updateProjectContractorCost,
  deleteProjectPartner,
  updateProjectPartner,
  putActivity,
  getOrgPartnersByKeywords,
  assignProjectPartner,
  getGuestContractors,
  getGuestVenues,
  addActivityMember,
} from '../../../../store/actions';

import {
  CustomTable,
  CustomTooltip,
  ViewMoreText,
  // EmptyContainer
} from '../../../../components';

import {
  datePickerEndTitle,
  datePickerStartTitle,
  getPageDisable,
  toSqlDate,
  threeDotSeparator,
} from '../../../../utils';

import {
  PartnerCreateFromActivity,
  PartnerUpdate,
  PartnerUpdateFromActivity,
} from '../../../organization/forms/contacts/partners';

import {
  isExternalLinkedActivity,
  isNetworkRelationship,
  isParentProgramActivity,
} from '../../../../utils/activity';

import { includes, cloneDeep } from '../../../../utils/lodash';
import { isLinkedActivity } from '../../../../utils/activity/financials';
import { getPermissionType } from '../../../../utils/activity/userPermission';
import { LocaleService } from '../../../../services';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import '../activity.scss';
import './financialHelpText.scss';
import './projectedContractorLabel.scss';
import './otherExpenditure.scss';

moment.locale('en-AU');

// sActivityPlanType: Grants Program
const GRANTS_PROGRAM_TYPE_ID = 4;

/**
 * TAK-2086: a currency amount saved on blur (Venue Hire, and the projected or
 * actual amount of a contractor or partner). `onSave(value)` gets the number
 * as a string with two decimals; an emptied field saves 0.
 */
class CostInput extends Component {
  constructor(props) {
    super(props);
    this.state = { value: thousands(props.value) || '' };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: thousands(this.props.value) || '' });
    }
  }

  handleChange = (value) => {
    if (value === '' || /^\d+\.?\d{0,2}$/.test(value)) {
      this.setState({ value });
    }
  };

  handleFocus = () => {
    this.setState((state) => ({
      value: String(state.value).replace(/,/g, ''),
    }));
  };

  handleBlur = () => {
    const { onSave } = this.props;
    const value = String(this.state.value).replace(/,/g, '');
    const amount = value === '' ? '0.00' : Number(value).toFixed(2);
    onSave(amount);
    this.setState({ value: thousands(amount) });
  };

  render() {
    const { currencyIconName, className, disabled } = this.props;
    return (
      <Input
        label={{
          basic: true,
          content: (
            <Icon
              circular
              inverted
              name={currencyIconName || 'dollar sign'}
              className="infoText"
            />
          ),
        }}
        labelPosition="left"
        className={className || 'input-icon-border-right'}
        onChange={(e) => this.handleChange(e.target.value)}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        value={this.state.value}
        placeholder="0.00"
        disabled={disabled}
      />
    );
  }
}

class ContractorView extends Component {
  constructor(props) {
    super(props);
    const { t, activity, actual, currentState, auth, helpTips } = this.props;
    this.state = {
      columns: [
        {
          width: 5,
          title: t('common.contractor'),
          render: (data) => {
            const occupationTitle = get(data, 'occupation.title', null);
            return (
              <div className="current-member-text">
                {data
                  ? data.companyName
                    ? threeDotSeparator({
                        name: data.companyName,
                        length: 45,
                        isPopUp: true,
                      })
                    : occupationTitle
                      ? threeDotSeparator({
                          name: occupationTitle,
                          length: 45,
                          isPopUp: true,
                        })
                      : null
                  : null}
                <div className="mt-1 mb-2">
                  {data.contractorCategory === 'projected' && (
                    <div className="projected-lbl projected-lbl--incomplete">
                      {t(
                        'activity.activity_plan.activity_input.projected_contractor_incomplete'
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          },
        },
        {
          width: 4,
          title: t('activity.activity_plan.activity_input.address'),
          render: (data) => {
            const address = data
              ? `${data.streetAddress !== null ? data.streetAddress : ''} ${
                  data.streetAddress2 !== null ? data.streetAddress2 : ''
                } ${data.suburb !== null ? data.suburb : ''} ${
                  data.state !== null ? data.state : ''
                } ${data.postCode !== null ? data.postCode : ''}`
              : '';

            return (
              <div className="current-member-text">
                {address.trim().length !== 0 ? address : ' - '}
              </div>
            );
          },
        },
        {
          width: 3,
          title: t('activity.activity_plan.activity_input.contractor_cost'),
          render: (data) => {
            return (
              <div className="disabled-padding pb-3">
                <Segment
                  disabled={getPageDisable(
                    activity.currentActivity,
                    auth.user,
                    currentState,
                    actual
                  )}
                >
                  <CostInput
                    value={
                      actual && data.actualCost != null
                        ? data.actualCost
                        : data.cost
                    }
                    currencyIconName={get(
                      activity,
                      'currentActivity.currencyType.iconName',
                      'dollar sign'
                    )}
                    className={
                      data.contractorCategory === 'projected'
                        ? 'projected-contractor-cost'
                        : 'input-icon-border-right'
                    }
                    onSave={(amount) =>
                      this.handleContractorCost(amount, data.id)
                    }
                  />
                  {actual && (
                    <label className="projected-value">
                      {t(
                        'activity.activity_plan.activity_input.projected_amount'
                      )}{' '}
                      {thousands(data.cost) || '0.00'}
                    </label>
                  )}
                </Segment>
              </div>
            );
          },
        },
        {
          width: 2,
          render: (data) => {
            return (
              <div className="disabled-padding">
                <Segment
                  disabled={getPageDisable(
                    activity.currentActivity,
                    auth.user,
                    currentState,
                    actual
                  )}
                >
                  <div className="current-member-text">
                    <ContractorUpdate
                      selectedContractor={data}
                      {...this.props}
                      projectId={activity.currentActivity.id}
                    />
                  </div>
                </Segment>
              </div>
            );
          },
        },
        {
          width: 2,
          render: (data) => {
            return (
              <div className="disabled-padding">
                <Segment
                  disabled={getPageDisable(
                    activity.currentActivity,
                    auth.user,
                    currentState,
                    actual
                  )}
                >
                  <CustomTooltip
                    state={get(auth, 'user.options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '102',
                    }}
                    // position="bottom left"
                    // wide="very"
                  >
                    <label
                      className="activity-actions-error-custom  mb-0"
                      onClick={() => this.handleContractorDelete(data.id)}
                    >
                      {t('actions.remove')}
                    </label>
                  </CustomTooltip>
                </Segment>
              </div>
            );
          },
        },
      ],
    };
  }

  handleContractorDelete = async (id) => {
    const { deleteProjectContractor, activity } = this.props;
    deleteProjectContractor('projectInput', activity.currentActivity.id, id);
  };

  handleContractorCost = async (value, id) => {
    const { updateProjectContractorCost, activity, actual } = this.props;
    updateProjectContractorCost(
      'projectInput',
      activity.currentActivity.id,
      id,
      {
        [actual ? 'actualCost' : 'cost']: value,
      }
    );
  };

  render() {
    const { contractors } = this.props.activity.currentActivity;
    const { columns } = this.state;
    const { t } = this.props;

    return (
      <CustomTable
        header
        columns={columns}
        data={contractors}
        emptyMessage={t('activity.activity_plan.activity_input.no_contractors')}
        keyExtractor={(item, index) => item.id}
      />
    );
  }
}

const ContractorViewWithTranslation = withTranslation()(ContractorView);

class PartnerView extends Component {
  constructor(props) {
    super(props);
    const { t, activity, actual, currentState, auth } = this.props;
    const disabled = getPageDisable(
      activity.currentActivity,
      auth.user,
      currentState,
      actual
    );

    this.state = {
      columns: [
        {
          width: 3,
          title: t('activity.activity_plan.activity_input.partner_name'),
          render: (data) => {
            const fullName =
              data && `${get(data, 'firstName')} ${get(data, 'secondName')}`;
            return (
              <>
                <div className="current-member-text pl-1 pt-1">
                  {data
                    ? data.isAnonymous
                      ? t(
                          'activity.activity_plan.activity_input.anonymous_donor'
                        )
                      : fullName.trim() && fullName
                    : null}
                </div>
                <div className="current-member-text pl-1 text-muted report-year-text-partner">
                  {data
                    ? data.isAnonymous
                      ? null
                      : data.organisationName && data.organisationName
                    : null}
                </div>
                {activity?.currentActivity?.parentActivity?.reportYear
                  ? isExternalLinkedActivity(data) && (
                      <div className="current-member-text pl-1 text-muted report-year-text-partner">
                        <div className="report-label">
                          {t('common.reporting_date')}
                        </div>
                        <div className="report-label report-space">
                          {activity.currentActivity.parentActivity
                            ? moment(
                                activity.currentActivity.parentActivity
                                  .reportYear
                              ).format('DD MMM YYYY')
                            : null}
                        </div>
                      </div>
                    )
                  : null}
              </>
            );
          },
        },
        {
          width: 5,
          title: t('common.description'),
          render: (data) => {
            return (
              <div className="project-partner-description">
                {data.description ? (
                  <ViewMoreText length={150} text={data.description} />
                ) : (
                  '-'
                )}
              </div>
            );
          },
        },
        {
          width: 3,
          title: t('activity.activity_plan.activity_input.contribution'),
          render: (data) => (
            <div className="disabled-padding pb-3">
              <Segment disabled={disabled}>
                {this.renderPartnerAmount(data)}
              </Segment>
            </div>
          ),
        },
        {
          width: 1,
          render: (data) => {
            return (
              <div className="disabled-padding">
                <div className="current-member-text">
                  <PartnerUpdate
                    selectedPartner={data}
                    viewOnly={
                      !!activity?.currentActivity?.parentActivity &&
                      isExternalLinkedActivity(data)
                    }
                    {...this.props}
                    isFromActivity={true}
                    projectId={activity.currentActivity.id}
                  />
                </div>
              </div>
            );
          },
        },

        {
          width: 1,
          title: (
            <div className="user-act-heading-container">
              <strong></strong>
            </div>
          ),
          render: (data) => {
            const ownerId = activity.currentActivity.owner.id;
            const members = activity.currentActivity.members;
            let isAlreadyMember = undefined;
            if (!isEmpty(data.userData)) {
              isAlreadyMember = find(
                members,
                (item) => item.userId === data.userData.id
              );
            }
            const isLinkedFromParentProgram =
              !!activity?.currentActivity?.parentActivity &&
              isExternalLinkedActivity(data);
            const dropDownView =
              (!data.isAnonymous &&
                isAlreadyMember === undefined &&
                ownerId === auth.user.id) ||
              !isLinkedFromParentProgram;

            return (
              <div className="org-users-text-partner">
                <div className="owned">
                  {dropDownView ? (
                    <Dropdown
                      icon="ellipsis vertical"
                      direction="left"
                      inline
                      selectOnBlur={false}
                    >
                      <Dropdown.Menu>
                        {!data.isAnonymous && isAlreadyMember === undefined ? (
                          <Dropdown.Item>
                            <InviteActivityMembers
                              data={data}
                              form={data}
                              {...this.props}
                              toggle={() => this.toggle()}
                            />
                          </Dropdown.Item>
                        ) : null}
                        {/* Edit-user without 'takso' tag */}
                        {!isLinkedFromParentProgram && (
                          <Dropdown.Item>
                            <div className="segment-change">
                              <Segment disabled={disabled}>
                                <div className="current-member-text">
                                  <CustomTooltip
                                    state={get(auth, 'user.options.tips')}
                                    content={t(
                                      'activity.activity_plan.activity_input.remove_partner_from_activity'
                                    )}
                                  >
                                    <label
                                      className="lable-center"
                                      onClick={() =>
                                        this.handlePartnerDelete(data.id)
                                      }
                                    >
                                      {t('actions.remove')}
                                    </label>
                                  </CustomTooltip>
                                </div>
                              </Segment>
                            </div>
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : null}
                </div>
              </div>
            );
          },
        },
      ],
    };
  }

  handlePartnerDelete = async (id) => {
    const { deleteProjectPartner, activity } = this.props;
    deleteProjectPartner('projectInput', activity.currentActivity.id, id);
  };

  handlePartnerCost = async (value, id) => {
    const { updateProjectPartner, activity, actual } = this.props;
    updateProjectPartner('projectInput', activity.currentActivity.id, id, {
      [actual ? 'actualCost' : 'cost']: value,
    });
  };

  /**
   * TAK-2086: what a partner adds to the Financial Result. Funding is an
   * editable amount (projected before green light, actual after) counted as
   * income; In-kind is a fixed value set in the partner's modal and not
   * counted; Network has no amount. On a linked activity the parent
   * program's own entry is shown read-only — its money is the Program
   * Contribution / Grant above.
   */
  renderPartnerAmount(data) {
    const { t, activity, actual } = this.props;
    const { currentActivity } = activity;
    const currencyIconName = get(
      currentActivity,
      'currencyType.iconName',
      'dollar sign'
    );
    const sign = get(currentActivity, 'currencyType.sign', '$');

    if (isNetworkRelationship(data.supportType)) {
      return (
        <label className="projected-value">
          {t('activity.activity_plan.activity_input.network_no_amount')}
        </label>
      );
    }
    if (data.supportType === 'IN_KIND') {
      return (
        <>
          <div className="current-member-text">
            {sign} {thousands(data.cost) || '0.00'}
          </div>
          <label className="projected-value">
            {t('activity.activity_plan.activity_input.in_kind_not_counted')}
          </label>
        </>
      );
    }
    if (isLinkedActivity(currentActivity) && data.isFromProgramLevel) {
      return (
        <>
          <div className="current-member-text">
            {sign}{' '}
            {thousands(
              actual && data.actualCost != null ? data.actualCost : data.cost
            ) || '0.00'}
          </div>
          <label className="projected-value">
            {t(
              'activity.activity_plan.activity_input.counted_as_program_amount'
            )}
          </label>
        </>
      );
    }
    return (
      <CustomTooltip
        state={get(this.props, 'auth.user.options.tips')}
        content={t(
          'activity.activity_plan.activity_input.estimated_value_partner_contribution'
        )}
        position="right center"
      >
        <span className="p-0 m-0">
          <CostInput
            value={
              actual && data.actualCost != null ? data.actualCost : data.cost
            }
            currencyIconName={currencyIconName}
            onSave={(amount) => this.handlePartnerCost(amount, data.id)}
          />
          {actual && (
            <label className="projected-value">
              {t('activity.activity_plan.activity_input.projected_amount')}{' '}
              {thousands(data.cost) || '0.00'}
            </label>
          )}
        </span>
      </CustomTooltip>
    );
  }

  render() {
    const { partners, currencyType } = this.props.activity.currentActivity;
    const { t } = this.props;
    const { columns } = this.state;

    // TAK-2086b: no totals line — like Venues and Contractors; the totals
    // are in the Documentation page's Financial Summary
    return (
      <CustomTable
        header
        columns={columns}
        data={partners}
        emptyMessage={t('activity.activity_plan.activity_input.no_partners')}
        keyExtractor={(item, index) => item.id}
        currencySymbol={get(currencyType, 'sign', '$')}
      />
    );
  }
}

const PartnerViewWithTranslation = withTranslation()(PartnerView);

class InviteActivityMembersBase extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
      searchQuery: '',
      form: {
        firstName: '',
        surName: '',
        email: '',
        message: '',
      },
      permissionType: undefined,
      radioType: undefined,
      collaborator: false,
      documentor: false,
      reportOnly: false,
      permissions: [],
      permissionError: false,
      modal: false,
      dropdownValuePermission: '',
      isCustomNotEmpty: true,
      isPermissionLabelVisible: false,
    };
  }

  componentDidMount() {
    const { t } = this.props;
    let permissionArray = permissionTypes(t).map((permissionType) => {
      return {
        name: permissionType.title,
        permission: {
          read: false,
          write: false,
        },
        state: permissionType.state,
      };
    });
    this.setState({ permissionArray });
  }

  componentWillMount() {
    this.resetComponent();
  }

  resetComponent = () =>
    this.setState({
      isLoading: false,
      data: [],
      searchQuery: '',
    });

  PERMISSION_OPTIONS = [
    {
      key: 'collaborator',
      text: <span>{this.props.t('permission_type.collaborator')}</span>,
      value: 'collaborator',
    },
    {
      key: 'documentor',
      text: <span>{this.props.t('permission_type.documentor')}</span>,
      value: 'documentor',
    },
    {
      key: 'reportOnly',
      text: <span>{this.props.t('permission_type.report_only')}</span>,
      value: 'reportOnly',
    },

    {
      key: 'custom',
      text: <span>{this.props.t('permission_type.custom')}</span>,
      value: 'custom',
    },
  ];

  selectPermissionType(value, name, checked) {
    const { t } = this.props;
    if (value === 'collaborator') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.title,
          permission: {
            read: true,
            write: RESTRICTION_TYPES.includes(permissionType.state)
              ? false
              : true,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.collaborator'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'collaborator',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'documentor') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.title,
          permission: {
            read: permissionType.documentor ? true : false,
            write: permissionType.documentor
              ? RESTRICTION_TYPES.includes(permissionType.state)
                ? false
                : true
              : false,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.documentor'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'documentor',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'reportOnly') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.title,
          permission: {
            read: permissionType.reportOnly ? true : false,
            write: permissionType.reportOnly
              ? RESTRICTION_TYPES.includes(permissionType.state)
                ? false
                : true
              : false,
          },
          state: permissionType.state,
        };
      });
      this.setState({
        permissionArray,
        permissionType: t('permission_type.report_only'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'reportOnly',
        isCustomNotEmpty: true,
        isPermissionLabelVisible: false,
      });
    } else if (value === 'custom') {
      let permissionArray = permissionTypes(t).map((permissionType) => {
        return {
          name: permissionType.title,
          permission: {
            read: false,
            write: false,
          },
          state: permissionType.state,
        };
      });

      let isCustomEmpty = permissionArray.map((item) => {
        return item.permission.read === false && item.permission.write === false
          ? true
          : false;
      });

      this.setState({
        permissionArray,
        permissionType: t('permission_type.custom'),
        radioType: value,
        permissionError: false,
        dropdownValuePermission: 'custom',
        isCustomNotEmpty: includes(isCustomEmpty, false),
        isPermissionLabelVisible: false,
      });
    }
  }

  selectPermissionOption(checked, value, id, type) {
    const { t } = this.props;

    this.setState((preState) => {
      let permissionArray = cloneDeep(preState.permissionArray);
      if (!checked && type === 'read') {
        permissionArray[id].permission.write = false;
      }
      permissionArray[id].permission[type] =
        !preState.permissionArray[id].permission[type];

      let dropdownValue = getPermissionType(permissionArray);

      let isCustomEmpty = permissionArray.map((item) => {
        return item.permission.read === false && item.permission.write === false
          ? true
          : false;
      });

      return {
        ...preState,
        permissionArray: permissionArray,
        permissionType: t('permission_type.custom'),
        radioType: undefined,
        permissionError: false,
        dropdownValuePermission: dropdownValue,
        isCustomNotEmpty: includes(isCustomEmpty, false),
        isPermissionLabelVisible: false,
      };
    });
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
      permissionType: undefined,
      dropdownValuePermission: '',
    }));
  }

  async onSubmit(values) {
    try {
      const { addActivityMember, data, activity } = this.props;
      const firstName = !isEmpty(data.userData)
        ? data.userData.firstName
        : data.firstName;
      const surname = !isEmpty(data.surName)
        ? data.userData.secondName
        : data.secondName;
      const email = data.email ? data.email : data.userData.email;
      const projectId = activity.currentActivity.id;

      const { permissionType, ...newValues } = {
        ...values,
        firstName,
        surname,
        email,
        projectId,
      };
      await addActivityMember(newValues);
      this.toggle();
    } catch (error) {
      console.error('error: ', error);
    }
  }

  render() {
    const { modal, dropdownValuePermission } = this.state;
    const { t } = this.props;

    return (
      <div className="button-outcome">
        <Modal
          open={modal}
          onOpen={() => this.toggle()}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
          className="contentOrganization-edit"
          size="small"
          trigger={
            <Dropdown.Item
              text={t(
                'activity.activity_plan.activity_input.invite_to_activity_member'
              )}
              className="segment-change"
            ></Dropdown.Item>
          }
        >
          <Modal.Header>
            {t(
              'activity.activity_plan.activity_input.invite_to_activity_member'
            )}
          </Modal.Header>
          <Modal.Content>
            <div className="new-member-segment-custom">
              <Formik
                onSubmit={(values) => this.onSubmit(values)}
                initialValues={initialValues()}
                validationSchema={activityInviteTypeValidation(t)}
              >
                {({
                  handleSubmit,
                  setFieldValue,
                  isSubmitting,
                  errors,
                  values,
                }) => {
                  return (
                    <Form onSubmit={handleSubmit}>
                      <div className="container">
                        <CustomTextArea
                          id="message"
                          name="message"
                          placeholder=""
                          labelText={t(
                            'activity.activity_plan.activity_input.message_for_invited_user'
                          )}
                          requiredStar
                        />
                        <UserPermissionsInput
                          search
                          selection
                          requiredStar
                          name="permissionType"
                          id="permissionType"
                          placeholder={t(
                            'formulary.placeholder.select_permission_type'
                          )}
                          labelText={t(
                            'activity.activity_plan.activity_input.permissions'
                          )}
                          options={this.PERMISSION_OPTIONS}
                          getValue={dropdownValuePermission}
                          setFieldValue={setFieldValue}
                        />
                      </div>
                      <div className="actions-invite-activity">
                        <Button.Group floated="right">
                          <div className="actions-invite-activity">
                            <Button
                              type="submit"
                              className="Primary-Button"
                              loading={isSubmitting}
                              // disabled={venueTypeLoading}
                            >
                              {t(
                                'activity.activity_plan.activity_input.invite'
                              )}
                            </Button>
                          </div>
                        </Button.Group>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const InviteActivityMembers = withTranslation()(InviteActivityMembersBase);

export class ActivityInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expenditure: !props.actual
        ? thousands(props.activity.currentActivity.projectedCost) || ''
        : thousands(props.activity.currentActivity.actualCost) || '',
      noExpenditure: props.activity.currentActivity.noExpenditure || false,
      inputDatesNote: props.activity.currentActivity.inputDatesNote || '',
      startDate: null,
      endDate: null,
      greenLightNotifyDate: '',
      venueLoading: false,
      venueResults: [],
      venueValue: '',
      contractorLoading: false,
      contractorResults: [],
      contractorValue: '',
      expenditureError: '',
      startDateError: '',
      endDateError: '',
      greenLightDateError: '',
      contractorCost: '',
      guestUserContractorsList: '',
      guestUserValue: '',
      guestUserVenuesList: '',
      guestUserVenueValue: '',
      contractorGuestLoading: false,
      venueGuestLoading: false,
      initialStartStateSettings: {
        autoApply: true,
        singleDatePicker: true,
        showDropdowns: true,
        startDate: props.activity.currentActivity.eventStartDate
          ? moment(props.activity.currentActivity.eventStartDate)
          : new Date(),

        minDate: moment('01-Jan-2017', 'DD-MMM-YYYY'),
        maxDate: props.activity.currentActivity.eventEndDate
          ? moment(props.activity.currentActivity.eventEndDate)
          : moment(
              `31-Dec-${parseInt(moment().format('YYYY'), 10) + 10}`,
              'DD-MMM-YYYY'
            ),
      },
      initialEndDateStateSettings: {
        autoApply: true,
        singleDatePicker: true,
        showDropdowns: true,
        startDate: props.activity.currentActivity.eventEndDate
          ? moment(props.activity.currentActivity.eventEndDate)
          : new Date(),

        maxDate: moment(
          `31-Dec-${parseInt(moment().format('YYYY'), 10) + 10}`,
          'DD-MMM-YYYY'
        ),
        minDate: props.activity.currentActivity.eventStartDate
          ? moment(props.activity.currentActivity.eventStartDate)
          : moment('01-Jan-2017', 'DD-MMM-YYYY'),
      },
      partnerLoading: false,
      partnerValue: '',
      partnerResults: [],
      addPartnerModal: false,
      selectedPartner: {},
    };

    this.keyStartDateRef = createRef(Date.now());
    this.keyEndDateRef = createRef(Date.now());
  }

  async componentDidMount() {
    this.resetComponent();
    const {
      // auth,
      // getOrgContractors,
      getOccupationTypes,
      getOccupation,
      getOrgVenuesTypes,
      getVenueTypes,
      // getOrgVenues,
      actual,
    } = this.props;

    const { currentActivity } = this.props.activity;

    getOrgVenuesTypes();
    getOccupationTypes();
    getOccupation();
    getVenueTypes();

    // if (!isEmpty(auth.user) && auth.user.organisation) {
    // getOrgVenues(auth.user.organisation.id);
    // getOrgContractors(auth.user.organisation.id);
    // }

    if (currentActivity.projectedCost || currentActivity.actualCost) {
      await this.setState({
        expenditure: !actual
          ? thousands(currentActivity.projectedCost)
          : thousands(currentActivity.actualCost),
        greenLightNotifyDate: currentActivity.greenLightNotifyDate
          ? moment(currentActivity.greenLightNotifyDate).format('DD MMM YYYY')
          : currentActivity.greenLightNotifyDate,
        startDate: currentActivity.eventStartDate
          ? moment(currentActivity.eventStartDate).format('DD MMM YYYY')
          : null,
        endDate: currentActivity.eventEndDate
          ? moment(currentActivity.eventEndDate).format('DD MMM YYYY')
          : null,
        actualVolunteers: currentActivity.actualVolunteers || '0',
        noExpenditure: currentActivity.noExpenditure || false,
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { currentActivity } = this.props.activity;
    const prevActivity = prevProps.activity.currentActivity;
    const { actual } = this.props;
    if (prevActivity !== currentActivity || prevProps.actual !== actual) {
      // Only sync noExpenditure from the API when switching to a different
      // activity or toggling Development/Actual — not on every data refresh.
      // This prevents the second-round-trip PUT (completionProgress) from
      // reverting a checkbox the user just ticked.
      const activityChanged =
        prevActivity.id !== currentActivity.id || prevProps.actual !== actual;

      await this.setState({
        // Only resync user-editable cost fields from Redux when switching to a
        // different activity or toggling Development/Active mode.  Resyncing on
        // every Redux refresh (e.g. putActivityStatus round-trip or a racing
        // setCurrentActivity GET after green light) would overwrite whatever
        // the user has typed before their blur-save has returned.
        ...(activityChanged && {
          expenditure: !actual
            ? thousands(currentActivity.projectedCost)
            : thousands(currentActivity.actualCost),
          noExpenditure: Boolean(currentActivity.noExpenditure),
        }),
        greenLightNotifyDate: currentActivity.greenLightNotifyDate
          ? moment(currentActivity.greenLightNotifyDate).format('DD MMM YYYY')
          : currentActivity.greenLightNotifyDate,
        startDate: currentActivity.eventStartDate
          ? moment(currentActivity.eventStartDate).format('DD MMM YYYY')
          : null,
        endDate: currentActivity.eventEndDate
          ? moment(currentActivity.eventEndDate).format('DD MMM YYYY')
          : null,
        actualVolunteers: currentActivity.actualVolunteers || '0',
        expenditureError: '',
        startDateError: '',
        endDateError: '',
        greenLightDateError: '',
      });
    }
  }

  resetComponent = (type) => {
    if (type === 'venue') {
      this.setState({
        venueLoading: false,
        venueResults: [],
        venueValue: '',
        venueGuestLoading: false,
      });
    } else if (type === 'contractor') {
      this.setState({
        contractorLoading: false,
        contractorResults: [],
        contractorValue: '',
        contractorGuestLoading: false,
      });
    }
  };

  handleResultSelect = (e, { result }, type) => {
    this.resetComponent(type);
    const { assignProjectVenue, assignProjectContractor, activity } =
      this.props;

    delete result.createdAt;
    delete result.updatedAt;
    if (type === 'venue') {
      if (result.dName) delete result.dName;
      if (result.dStreetAddress) delete result.dStreetAddress;
      assignProjectVenue('projectInput', activity.currentActivity.id, {
        venue: result,
      });
    } else if (type === 'contractor') {
      delete result.createdBy;
      if (result.dFirstName) delete result.dFirstName;
      if (result.dSecondName) delete result.dSecondName;
      if (result.dCompanyName) delete result.dCompanyName;
      if (result.dEmail) delete result.dEmail;
      assignProjectContractor('projectInput', activity.currentActivity.id, {
        contractor: result,
      });
    }
  };

  handleGuestSearch = async (e, { value }, type) => {
    try {
      const {
        getGuestContractors,
        getGuestVenues,
        activity: { currentActivity },
      } = this.props;

      if (type === 'contractor') {
        this.setState({
          contractorGuestLoading: true,
          guestUserValue: value,
        });
        await getGuestContractors(currentActivity.ownerId, value);
        const { guestUserContractors } = this.props.organization;
        setTimeout(() => {
          if (this.state.guestUserValue.length < 1)
            return this.resetComponent(type);
          this.setState({
            contractorGuestLoading: false,
            guestUserContractorsList: guestUserContractors,
          });
        }, 300);
      } else {
        this.setState({
          venueGuestLoading: true,
          guestUserVenueValue: value,
        });
        await getGuestVenues(currentActivity.ownerId, value);
        const { guestUserVenues } = this.props.organization;
        setTimeout(() => {
          if (this.state.guestUserVenueValue.length < 1)
            return this.resetComponent(type);
          this.setState({
            venueGuestLoading: false,
            guestUserVenuesList: guestUserVenues,
          });
        }, 300);
      }
    } catch (error) {
      // console.error('handleSearchChange -> error', error);
    }
  };

  getUserVenueContractorPartnerAccess = () => {
    const {
      activity: { currentActivity },
      user,
    } = this.props;

    // activity owner organisation id
    let data = {
      create: false,
      guestUserId: null,
      search: false,
      organisationId: null,
    };

    const allUserPermissions = currentActivity.members;
    const currentUserPermissions = allUserPermissions.find(
      (item) => item.userId === user.id
    );

    // if member doesn't have any permission to this activity
    if (!currentUserPermissions) {
      return data;
    }

    const activityPlanPermission = currentUserPermissions.permissions.find(
      (item) => item.state === 'project.edit.activityPlan'
    );

    if (!activityPlanPermission.permission.write) {
      return data;
    }

    const isActivityOwner = currentActivity.ownerId === user.id;

    const isGuestUser = !user.organisationId;

    // check activity is linked (exclude single activity)
    const isLinkedActivity =
      currentActivity.isLinkedActivity &&
      currentActivity.activityPlanTypeId === 1;

    // FIXME: need to check ser has permission to activity plan
    // Current user is not a guest
    if (!isGuestUser) {
      const isSameOrganisation =
        currentActivity.owner.organisationId === user.organisationId;

      /*
       * organisation data means venues, contractors, partners
       */

      // current user in same organisation
      if (isSameOrganisation) {
        // able to add and search organisation data
        data.create = true; // able to create organisation data to activity owned organisation
        data.search = true; // able to search organisation data to activity owned organisation
        data.organisationId = user.organisationId; // eq currentActivity.owner.organisationId
      } else {
        // current user is from different organisation

        // activity is linked activity
        if (isLinkedActivity) {
          // if linked activity is owned by different organisation user
          if (isActivityOwner) {
            // current user is the owner
            data.create = true; // able to create organisation data to activity owner organisation (different organisation)
            data.search = true; // able to search organisation data to activity owner organisation (different organisation)
            data.organisationId = user.organisationId; // current user organisation id (different organisation id)
          } else {
            // current user is collaborator
            data.create = true; // create organisation data by guest user id
            data.guestUserId = currentActivity.owner.id; // is user is guest
            data.search = false; // Unable to access organisation data
            data.organisationId = null;
          }
        } else {
          // not activity owner (collaborator)

          // single + program activity
          if (isActivityOwner) {
            // current user is the owner
            data.create = true; // able to create organisation data to activity owned organisation
            data.search = true; // able to search organisation data to activity owned organisation
            data.organisationId = user.organisationId; // eq currentActivity.owner.organisationId
          } else {
            // current user is collaborator
            data.create = true; // able to create organisation data to activity owned organisation
            data.search = true; // able to search organisation data to activity owned organisation
            data.organisationId = currentActivity.owner.organisationId; // eq currentActivity.owner.organisationId
          }
        }
      }
    } else {
      // is current user is guest

      // activity is linked activity
      if (isLinkedActivity) {
        /*
         * if guest user is the owner of the linked activity or
         * if guest user is collaborator of the linked activity
         */
        data.create = true; // create organisation data by guest user id
        data.guestUserId = currentActivity.owner.id; // is user is guest
        data.search = false;
        data.organisationId = null;
      } else {
        // NOTE: Activity owner can not be guest users cannot create activities
        /*
         * if guest user is collaborator of the single + program activity
         */
        data.create = true;
        data.search = true;
        data.organisationId = currentActivity.owner.organisationId;
      }
    }

    return data;
  };

  handleSearchChange = async (e, { value }, type, organisationId) => {
    try {
      const {
        getOrgContractors,
        getOrgVenues,
        activity: { currentActivity },
      } = this.props;

      if (type === 'venue') {
        this.setState({ venueLoading: true, venueValue: value });
        await getOrgVenues(value, currentActivity.id);
        const { orgVenues } = this.props.organization;
        setTimeout(() => {
          if (this.state.venueValue.length < 1)
            return this.resetComponent(type);
          this.setState({
            venueLoading: false,
            venueResults: orgVenues,
          });
        }, 300);
      } else if (type === 'contractor') {
        this.setState({
          contractorLoading: true,
          contractorValue: value,
        });
        await getOrgContractors(value, currentActivity.id);
        const { orgContractors } = this.props.organization;
        setTimeout(() => {
          if (this.state.contractorValue.length < 1)
            return this.resetComponent(type);
          this.setState({
            contractorLoading: false,
            contractorResults: orgContractors,
          });
        }, 300);
      }
    } catch (error) {
      // console.error('handleSearchChange -> error', error);
    }
  };

  handlePartnerSearchChange = async (e, { value }, organisationId) => {
    const { getOrgPartnersByKeywords } = this.props;
    this.setState({
      partnerLoading: true,
      partnerValue: value,
    });

    await getOrgPartnersByKeywords(value);

    const { orgPartners } = this.props.organization;
    setTimeout(() => {
      if (this.state.partnerValue.length < 1) {
        this.setState({
          partnerLoading: false,
          partnerResults: [],
          partnerValue: '',
        });
        return;
      }
      this.setState({
        partnerLoading: false,
        partnerResults: orgPartners,
      });
    }, 300);
  };

  handlePartnerResultSelect = (e, { result }, type) => {
    this.resetComponent(type);
    this.setState({ addPartnerModal: true });
  };

  async onChange(value, data, type) {
    const { t } = this.props;

    if (type === 'expenditure') {
      var isNum = /^-?\d+\.?\d*$/.test(value);
      if (!isNum) {
        this.setState({
          expenditureError: t(
            'activity.activity_plan.activity_input.only_numbers_can_be_entered'
          ),
        });
      } else {
        this.setState({
          expenditureError: '',
        });
      }
      this.setState({
        expenditure: value,
      });
    }
  }

  async onFocus(value, data, type) {
    if (type === 'expenditure') {
      value = value.replace(/,/g, '');
      this.setState({
        expenditure: value,
      });
    }
  }

  handleBlur = (type) => {
    const { t, updateProjectInputs, activity, actual } = this.props;
    if (type === 'expenditure') {
      const { expenditure } = this.state;
      if (expenditure) {
        let value = expenditure.replace(/,/g, '');
        var isNum = /^-?\d+\.?\d*$/.test(value);
        if (isNum) {
          const data = {
            completionProgress: activity.currentActivity.completionProgress,
          };
          if (!actual) {
            data.projectedCost = value;
          } else {
            data.actualCost = value;
          }
          updateProjectInputs('projectInput', activity.currentActivity.id, {
            data,
          });
        }
      }
    }
  };

  handleNoExpenditureChange = (checked) => {
    const { updateProjectInputs, setActivityState, activity } = this.props;
    this.setState({ noExpenditure: checked, expenditureError: '' });
    // Optimistically update Redux immediately so the Evaluation page sees the
    // correct value before the API response comes back (avoids race condition).
    setActivityState({ noExpenditure: checked }, false);
    updateProjectInputs('projectInput', activity.currentActivity.id, {
      data: { noExpenditure: checked },
    });
  };

  handleInputDatesNoteChange = (value) => {
    this.setState({ inputDatesNote: value });
  };

  handleInputDatesNoteBlur = () => {
    const { putActivity } = this.props;
    putActivity('projectInput', { inputDatesNote: this.state.inputDatesNote });
  };

  getColumns(currentActivity, auth, currentState, actual, helpTips) {
    const { t } = this.props;

    return [
      {
        title: t('formulary.venue_name'),
        render: (data) => {
          return (
            <div className="current-member-text">
              {data.createdBySystem ? (
                <CustomTooltip
                  state={get(auth, 'user.options.tips')}
                  contentObject={{
                    data: helpTips,
                    key: '220',
                  }}
                  position="bottom left"
                  wide="very"
                >
                  <label>{data ? (data.name ? data.name : '-') : '-'}</label>
                </CustomTooltip>
              ) : data ? (
                data.name ? (
                  data.name
                ) : (
                  '-'
                )
              ) : (
                '-'
              )}
            </div>
          );
        },
      },
      {
        title: t('formulary.address'),
        render: (data) => {
          const address =
            data &&
            `
          ${data.streetAddress !== null ? data.streetAddress : ''} ${
            data.streetAddress2 !== null ? data.streetAddress2 : ''
          } ${data.suburb !== null ? data.suburb : ''} ${
            data.state !== null ? data.state : ''
          } ${data.postCode !== null ? data.postCode : ''}
        `;
          return <div>{data.streetAddress !== null ? address : '-'}</div>;
        },
      },
      {
        title: t('formulary.venue_type'),
        render: (data) => {
          return (
            <div className="current-member-label">
              {data.venueType
                ? data.venueType.name
                  ? data.venueType.name
                  : null
                : null}
            </div>
          );
        },
      },
      {
        // TAK-2086: Venue Hire, counted as an expense
        title: actual
          ? t('activity.activity_plan.activity_input.actual_venue_hire')
          : t('activity.activity_plan.activity_input.venue_hire'),
        render: (data) => (
          <div className="disabled-padding">
            <Segment
              disabled={getPageDisable(
                currentActivity,
                auth.user,
                currentState,
                actual
              )}
            >
              <CostInput
                value={actual ? data.actualCost : data.cost}
                currencyIconName={get(
                  currentActivity,
                  'currencyType.iconName',
                  'dollar sign'
                )}
                onSave={(amount) => this.handleVenueHire(data.id, amount)}
              />
              {actual && (
                <label className="projected-value">
                  {t('activity.activity_plan.activity_input.projected_amount')}{' '}
                  {thousands(data.cost) || '0.00'}
                </label>
              )}
            </Segment>
          </div>
        ),
      },
      // {
      //   title: '',
      //   render: data => {
      //     return (
      //       <div className="current-member-label">
      //         <Segment
      //           disabled={getPageDisable(
      //             currentActivity,
      //             auth.user,
      //             currentState,
      //             actual
      //           )}
      //         >
      //           <VenueUpdate
      //             venue={data}
      //             {...this.props}
      //             projectId={currentActivity.id}
      //           />
      //         </Segment>
      //       </div>
      //     );
      //   },
      // },
      {
        title: '',
        render: (data) => {
          if (!data.createdBySystem) {
            return (
              <div className="current-member-label">
                <Segment
                  disabled={getPageDisable(
                    currentActivity,
                    auth.user,
                    currentState,
                    actual
                  )}
                  className="action-container"
                >
                  <VenueUpdate
                    venue={data}
                    {...this.props}
                    projectId={currentActivity.id}
                  />
                  <CustomTooltip
                    state={get(auth, 'user.options.tips')}
                    contentObject={{
                      data: helpTips,
                      key: '101',
                    }}
                    position="bottom left"
                    wide="very"
                  >
                    <label
                      className="activity-actions-error first-down mb-0"
                      onClick={() => {
                        this.handleVenueDelete(data.id);
                      }}
                    >
                      {t('actions.remove')}
                    </label>
                  </CustomTooltip>
                </Segment>
              </div>
            );
          } else {
            return null;
          }
        },
      },
    ];
  }

  handleVenueHire = (venueId, amount) => {
    const { updateProjectVenueCost, activity, actual } = this.props;
    updateProjectVenueCost(
      'projectInput',
      activity.currentActivity.id,
      venueId,
      {
        [actual ? 'actualCost' : 'cost']: amount,
      }
    );
  };

  async handleVenueDelete(id) {
    const { deleteProjectVenue, activity } = this.props;
    deleteProjectVenue('projectInput', activity.currentActivity.id, id);
  }

  renderVenueCard(userContractorVenuePartnerData) {
    const { t, auth, helpTips, activity, actual, currentState } = this.props;

    const { venues } = this.props.activity.currentActivity;
    return (
      <CustomTable
        header
        columns={this.getColumns(
          activity.currentActivity,
          auth,
          currentState,
          actual,
          helpTips,
          userContractorVenuePartnerData
        )}
        data={venues}
        customClass="venue-table"
        emptyMessage={t('activity.activity_plan.activity_input.no_venues')}
        keyExtractor={(item, index) => item.id}
      />
    );
  }

  handleContractorDelete = async (id) => {
    const { deleteProjectContractor, activity } = this.props;
    deleteProjectContractor('projectInput', activity.currentActivity.id, id);
  };

  handleContractorCost = async (value, id) => {
    const { updateProjectContractorCost, activity } = this.props;
    const form = {
      cost: value,
    };
    updateProjectContractorCost(
      'projectInput',
      activity.currentActivity.id,
      id,
      form
    );
  };

  onChangeInput(value, type) {
    var isNum = /^-?\d+\.?\d*$/.test(value);
    if (isNum) {
      this.setState({ [type]: value });
    } else if (value === '') {
      this.setState({ [type]: value });
    }
  }

  onBlurInput(type) {
    const { putActivity } = this.props;
    let value = this.state[type] ? this.state[type] : 0;
    putActivity('projectInput', { [type]: value });
  }

  handleGreenLightDateChange = (event, value) => {
    const isValidDate = moment(value.startDate, 'DD-MMM-YYYY', true).isValid();
    if (isValidDate) {
      const { updateProjectInputs, activity } = this.props;
      updateProjectInputs('projectInput', activity.currentActivity.id, {
        data: {
          completionProgress: activity.currentActivity.completionProgress,
          greenLightNotifyDate: value.startDate,
        },
      });
    }
  };

  handleActivityStartDateChange = (event, value) => {
    const isValidDate = moment(value.startDate, 'DD-MMM-YYYY', true).isValid();
    if (isValidDate) {
      const { initialEndDateStateSettings, initialStartStateSettings } =
        this.state;
      const { updateProjectInputs, activity } = this.props;

      updateProjectInputs('projectInput', activity.currentActivity.id, {
        data: {
          eventStartDate: value.startDate,
        },
      });
      this.keyEndDateRef.current = value.startDate;

      this.setState({
        initialStartStateSettings: {
          ...initialStartStateSettings,
          startDate: value.startDate,
        },
        initialEndDateStateSettings: {
          ...initialEndDateStateSettings,
          minDate: value.startDate,
        },
      });
    }
  };

  handleActivityEndDateChange = (event, value) => {
    const isValidDate = moment(value.startDate, 'DD-MMM-YYYY', true).isValid();

    if (isValidDate) {
      const { initialStartStateSettings, initialEndDateStateSettings } =
        this.state;
      const { updateProjectInputs, activity } = this.props;

      updateProjectInputs('projectInput', activity.currentActivity.id, {
        data: {
          completionProgress: activity.currentActivity.completionProgress,
          eventEndDate: value.startDate,
        },
      });

      this.keyStartDateRef.current = value.endDate;
      this.setState({
        initialStartStateSettings: {
          ...initialStartStateSettings,
          maxDate: value.endDate,
        },
        initialEndDateStateSettings: {
          ...initialEndDateStateSettings,
          startDate: value.endDate,
        },
      });
    }
  };

  datePicker = async (event, picker) => {
    const { updateProjectInputs, activity } = this.props;
    let startDate = picker.startDate;
    let endDate = picker.endDate;
    if (startDate && endDate) {
      updateProjectInputs('projectInput', activity.currentActivity.id, {
        data: {
          completionProgress: activity.currentActivity.completionProgress,
          eventStartDate: toSqlDate(
            toSqlDate(moment(startDate).format('YYYY-MMM-DD'))
          ),
          eventEndDate: toSqlDate(
            toSqlDate(moment(endDate).format('YYYY-MMM-DD'))
          ),
        },
      });
      this.setState({
        startDate,
        endDate,
      });
    }
  };

  /**
   * TAK-2086: Program Contribution (or Program Grant, under a Grants Program)
   * on a linked activity — first financial input on the card, for every
   * manager. Read-only: the program allocates it (Add Linked Activity modal,
   * grantee CSV upload, or the program's Activation information modal).
   */
  renderProgramAmount() {
    const { t, actual, activity } = this.props;
    const { currentActivity } = activity;
    if (!isLinkedActivity(currentActivity)) {
      return null;
    }

    const isGrant =
      get(currentActivity, 'parentActivity.activityPlanTypeId') ===
      GRANTS_PROGRAM_TYPE_ID;
    const labelKey = isGrant
      ? actual
        ? 'expenditure_status.actual_program_grant'
        : 'expenditure_status.program_grant'
      : actual
        ? 'expenditure_status.actual_program_contribution'
        : 'expenditure_status.program_contribution';
    const amount = actual
      ? currentActivity.actualGrantAmount
      : currentActivity.projectedGrantAmount;

    return (
      <Grid.Row className="inputs-row">
        <Grid.Column
          mobile={16}
          tablet={16}
          computer={8}
          className="extra-padding program-amount-column"
        >
          <div className="expenditure-div">
            <Label>{t(labelKey)}</Label>
            <InputGroup className="icon-inputs-style-custom">
              <InputGroupAddon addonType="prepend">
                <Icon
                  circular
                  inverted
                  name={get(
                    currentActivity,
                    'currencyType.iconName',
                    'dollar sign'
                  )}
                  color="grey"
                />
              </InputGroupAddon>
              <Input
                className="expenditure-input expenditure-input-custom"
                value={thousands(amount) || '0.00'}
                readOnly
                disabled
              />
            </InputGroup>
            {actual && (
              <label className="projected-value">
                {t(
                  isGrant
                    ? 'activity.activity_plan.activity_input.projected_program_grant'
                    : 'activity.activity_plan.activity_input.projected_program_contribution'
                )}{' '}
                {thousands(currentActivity.projectedGrantAmount)}
              </label>
            )}
            <div className="field-help-text">
              {t('activity.activity_plan.activity_input.program_amount_help')}
            </div>
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }

  /**
   * TAK-2086: a program's own pool — its Program Contribution (Program Grant
   * for a Grants Program) to allocate to linked activities, editable here,
   * beside what has been allocated so far and what remains. Allocations are
   * set per linked activity (Add Linked Activity, grantee CSV upload, or the
   * linked activity's Activation information).
   */
  renderProgramFund() {
    const { t, actual, activity, auth, currentState, updateProjectInputs } =
      this.props;
    const { currentActivity } = activity;
    if (!isParentProgramActivity(currentActivity.activityPlanTypeId)) {
      return null;
    }

    const isGrant =
      currentActivity.activityPlanTypeId === GRANTS_PROGRAM_TYPE_ID;
    const fieldName = actual ? 'actualProgramFund' : 'projectedProgramFund';
    const fund = Number(currentActivity[fieldName] || 0);
    const allocated = Number(
      get(
        currentActivity,
        ['programFundAllocated', actual ? 'actual' : 'projected'],
        0
      )
    );
    const remaining = fund - allocated;
    const currencyIconName = get(
      currentActivity,
      'currencyType.iconName',
      'dollar sign'
    );
    const key = (name) => `activity.activity_plan.activity_input.${name}`;

    return (
      <Grid.Row className="inputs-row">
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={4}
          className="extra-padding"
        >
          <div className="disabled-padding">
            <Segment
              disabled={getPageDisable(
                currentActivity,
                auth.user,
                currentState,
                actual
              )}
            >
              <div className="expenditure-div">
                <Label>
                  {t(
                    key(
                      isGrant
                        ? actual
                          ? 'actual_program_grant_fund'
                          : 'program_grant_fund'
                        : actual
                          ? 'actual_program_contribution_fund'
                          : 'program_contribution_fund'
                    )
                  )}
                </Label>
                <CostInput
                  value={currentActivity[fieldName]}
                  currencyIconName={currencyIconName}
                  onSave={(amount) =>
                    updateProjectInputs('projectInput', currentActivity.id, {
                      data: { [fieldName]: Number(amount) },
                    })
                  }
                />
                {actual && (
                  <label className="projected-value">
                    {t(key('projected_amount'))}{' '}
                    {thousands(currentActivity.projectedProgramFund) || '0.00'}
                  </label>
                )}
              </div>
            </Segment>
          </div>
        </Grid.Column>
        <Grid.Column
          mobile={16}
          tablet={8}
          computer={4}
          className="extra-padding"
        >
          <div className="expenditure-div">
            <Label>
              {t(key(isGrant ? 'grants_allocated' : 'contribution_allocated'))}
            </Label>
            <InputGroup className="icon-inputs-style-custom">
              <InputGroupAddon addonType="prepend">
                <Icon circular inverted name={currencyIconName} color="grey" />
              </InputGroupAddon>
              <Input
                className="expenditure-input expenditure-input-custom"
                value={thousands(allocated) || '0.00'}
                readOnly
                disabled
              />
            </InputGroup>
            <label
              className={
                remaining < 0 ? 'projected-value error-text' : 'projected-value'
              }
            >
              {t(key('program_fund_remaining'))} {remaining < 0 ? '-' : ''}
              {thousands(Math.abs(remaining)) || '0.00'}
            </label>
          </div>
        </Grid.Column>
      </Grid.Row>
    );
  }

  render() {
    const {
      venueLoading,
      venueResults,
      venueValue,
      expenditureError,
      startDateError,
      endDateError,
      greenLightDateError,
      actualVolunteers,
      greenLightNotifyDate,
      expenditure,
      // contractorGuestLoading,
      startDate,
      endDate,
      initialStartStateSettings,
      initialEndDateStateSettings,
      // partnerDescriptionModal,
      partnerResults,
      partnerValue,
      partnerLoading,
      addPartnerModal,
      selectedPartner,
      contractorLoading,
      contractorResults,
      contractorValue,
      noExpenditure,
      inputDatesNote,
    } = this.state;

    const { t, actual, activity, auth, helpTips, currentState } = this.props;

    let exist = {};
    if (
      activity.currentActivity.eventStartDate &&
      activity.currentActivity.eventEndDate
    ) {
      exist.value = `${moment(startDate).format('DD MMM YYYY')} - ${moment(
        endDate
      ).format('DD MMM YYYY')}`;
    }

    let existGreenLightNotifyDate = { value: '' };
    if (greenLightNotifyDate) {
      existGreenLightNotifyDate.value = `${moment(greenLightNotifyDate).format(
        'DD MMM YYYY'
      )}`;
    } else if (activity.currentActivity.greenLightDateError) {
      existGreenLightNotifyDate.value = `${moment(greenLightDateError).format(
        'DD MMM YYYY'
      )}`;
    }

    let existStartDate = { value: '' };
    if (startDate) {
      existStartDate.value = `${moment(startDate).format('DD MMM YYYY')}`;
    } else if (activity.currentActivity.startDateError) {
      existStartDate.value = `${moment(startDateError).format('DD MMM YYYY')}`;
    }

    let existEndDate = { value: '' };
    if (endDate) {
      existEndDate.value = `${moment(endDate).format('DD MMM YYYY')}`;
    } else if (activity.endDateError) {
      existEndDate.value = `${moment(endDateError).format('DD MMM YYYY')}`;
    }

    const userContractorVenuePartnerData =
      this.getUserVenueContractorPartnerAccess();

    // TAK-1714: what the Partners section covers on a linked activity / program
    const partnersHelpKey = isLinkedActivity(activity.currentActivity)
      ? 'activity.activity_plan.activity_input.partners_help_linked'
      : isParentProgramActivity(activity.currentActivity.activityPlanTypeId)
        ? 'activity.activity_plan.activity_input.partners_help_program'
        : null;

    return (
      <div className="document-input">
        <Segment className="inputs-segment">
          <Grid columns={2} stackable>
            <Grid.Row className="inputs-row">
              {actual ? null : (
                <Grid.Column
                  mobile={16}
                  tablet={8}
                  computer={4}
                  className="date-input-row extra-padding"
                >
                  <div className="disabled-padding">
                    <Segment
                      disabled={getPageDisable(
                        activity.currentActivity,
                        auth.user,
                        currentState,
                        actual
                      )}
                    >
                      <CustomTooltip
                        state={get(auth, 'user.options.tips')}
                        contentObject={{
                          data: helpTips,
                          key: '108',
                        }}
                        position="top left"
                      >
                        <Label className="plan-input-label">
                          {t(
                            'activity.activity_plan.activity_input.green_light_date'
                          )}
                        </Label>
                      </CustomTooltip>
                      <form autoComplete="off">
                        <div className="date-range-container">
                          <DateRangePicker
                            initialSettings={{
                              drops: 'auto',
                              autoApply: true,
                              singleDatePicker: true,
                              showDropdowns: true,
                              startDate: new Date(),
                              minDate: moment('01-Jan-2017', 'DD-MMM-YYYY'),
                              maxDate: moment(
                                `31-Dec-${
                                  parseInt(moment().format('YYYY'), 10) + 10
                                }`,
                                'DD-MMM-YYYY'
                              ),
                            }}
                            onApply={this.handleGreenLightDateChange}
                            value={greenLightNotifyDate}
                          >
                            <div className="date-range-chart p-1">
                              <input
                                {...existGreenLightNotifyDate}
                                placeholder={t(
                                  'date.placeholder_format_dd_mm_yyyy'
                                )}
                                type="text"
                                readOnly
                                className="date-range-chart-date"
                              />
                              <Icon name="calendar alternate outline" />
                            </div>
                          </DateRangePicker>
                        </div>
                      </form>
                      <div
                        className={
                          greenLightDateError
                            ? 'error-msg-div'
                            : 'error-msg-hidden'
                        }
                      >
                        {greenLightDateError}
                      </div>
                    </Segment>
                  </div>
                </Grid.Column>
              )}

              <Grid.Column
                mobile={16}
                tablet={8}
                computer={4}
                className="date-padding date-input-row extra-padding"
              >
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    <CustomTooltip
                      state={get(auth, 'user.options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '74',
                      }}
                      position="top left"
                    >
                      <Label className="plan-input-label">
                        {datePickerStartTitle(activity.currentActivity)}
                      </Label>
                    </CustomTooltip>
                    <form autoComplete="off">
                      <div className="date-range-container">
                        <DateRangePicker
                          key={this.keyStartDateRef.current}
                          initialSettings={{
                            drops: 'auto',
                            ...initialStartStateSettings,
                          }}
                          onApply={this.handleActivityStartDateChange}
                          value={startDate}
                        >
                          <div className="date-range-chart p-1">
                            <input
                              {...existStartDate}
                              placeholder={t(
                                'date.placeholder_format_dd_mm_yyyy'
                              )}
                              type="text"
                              readOnly
                              className="date-range-chart-date"
                            />
                            <Icon name="calendar alternate outline" />
                          </div>
                        </DateRangePicker>
                      </div>
                    </form>
                  </Segment>
                </div>
              </Grid.Column>

              <Grid.Column
                mobile={16}
                tablet={8}
                computer={4}
                className="date-padding date-input-row extra-padding"
              >
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    <CustomTooltip
                      state={get(auth, 'user.options.tips')}
                      contentObject={{
                        data: helpTips,
                        key: '74',
                      }}
                      position="top left"
                    >
                      <Label className="plan-input-label">
                        {datePickerEndTitle(activity.currentActivity, t)}
                      </Label>
                    </CustomTooltip>
                    <form autoComplete="off">
                      <div className="date-range-container">
                        <DateRangePicker
                          key={this.keyEndDateRef.current}
                          initialSettings={{
                            drops: 'auto',
                            ...initialEndDateStateSettings,
                          }}
                          onApply={this.handleActivityEndDateChange}
                          value={endDate}
                        >
                          <div className="date-range-chart p-1">
                            <input
                              {...existEndDate}
                              placeholder={t(
                                'date.placeholder_format_dd_mm_yyyy'
                              )}
                              type="text"
                              readOnly
                              className="date-range-chart-date"
                            />
                            <Icon name="calendar alternate outline" />
                          </div>
                        </DateRangePicker>
                      </div>
                    </form>
                  </Segment>
                </div>
              </Grid.Column>
            </Grid.Row>
            {actual && (
              <Grid.Row className="inputs-row">
                <Grid.Column
                  mobile={16}
                  tablet={16}
                  computer={8}
                  className="date-padding extra-padding date-input-row"
                >
                  <div className="disabled-padding">
                    <Segment
                      disabled={getPageDisable(
                        activity.currentActivity,
                        auth.user,
                        currentState,
                        actual
                      )}
                    >
                      <div className="eval-narrative-wrap">
                        <label className="dates-note-label">
                          {t(
                            'activity.activity_plan.activity_input.note_on_dates_and_timing.label'
                          )}
                        </label>
                        <textarea
                          className="eval-narrative-textarea"
                          rows={3}
                          value={inputDatesNote}
                          placeholder={t(
                            'activity.activity_plan.activity_input.note_on_dates_and_timing.placeholder'
                          )}
                          disabled={getPageDisable(
                            activity.currentActivity,
                            auth.user,
                            currentState,
                            actual
                          )}
                          onChange={(e) =>
                            this.handleInputDatesNoteChange(e.target.value)
                          }
                          onBlur={this.handleInputDatesNoteBlur}
                        />
                      </div>
                    </Segment>
                  </div>
                </Grid.Column>
              </Grid.Row>
            )}
            {actual && (
              <Grid.Row className="inputs-row">
                <Grid.Column
                  mobile={16}
                  tablet={8}
                  computer={3}
                  className="extra-padding"
                >
                  <div className="disabled-padding">
                    <Segment
                      disabled={getPageDisable(
                        activity.currentActivity,
                        auth.user,
                        currentState,
                        actual
                      )}
                    >
                      <div className="expenditure-div">
                        <CustomTooltip
                          state={get(auth, 'user.options.tips')}
                          contentObject={{
                            data: helpTips,
                            key: '133',
                          }}
                          position="top left"
                          wide="very"
                        >
                          <Label className="plan-input-label">
                            {t(
                              'activity.activity_plan.activity_input.total_volunteers'
                            )}
                          </Label>
                        </CustomTooltip>
                        <Input
                          className={'end-date volunteer-input'}
                          name="actualVolunteers"
                          type="text"
                          value={actualVolunteers}
                          defaultValue={
                            activity.currentActivity
                              ? activity.currentActivity.actualVolunteers
                              : '0'
                          }
                          onChange={(e) =>
                            this.onChangeInput(
                              e.target.value,
                              'actualVolunteers'
                            )
                          }
                          onBlur={() => this.onBlurInput('actualVolunteers')}
                        />
                        {activity.currentActivity?.volunteerHoursValue !==
                          null && (
                          <p className="volunteer-hours-value">
                            {t(
                              'activity.activity_plan.activity_input.estimated_value'
                            )}
                            :{' '}
                            {LocaleService.fmtLocaleCurrency(
                              activity.currentActivity.volunteerHoursValue
                            )}
                          </p>
                        )}
                      </div>
                    </Segment>
                  </div>
                </Grid.Column>
              </Grid.Row>
            )}
            {this.renderProgramAmount()}
            {this.renderProgramFund()}
            <Divider section />
            <Grid.Row>
              {/* <Grid.Column
                mobile={16}
                tablet={16}
                computer={16}
                className="hr-extra-padding"
              >
                <hr></hr>
              </Grid.Column> */}
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <label className="venue-custom">
                  {t('activity.activity_plan.activity_input.venue')}
                </label>

                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    {userContractorVenuePartnerData.search && (
                      <div className="venue-label-div">
                        <CustomTooltip
                          state={get(auth, 'user.options.tips')}
                          contentObject={
                            actual
                              ? {
                                  data: helpTips,
                                  key: '134',
                                }
                              : {
                                  data: helpTips,
                                  key: '126',
                                }
                          }
                          position="top left"
                        >
                          <label className="add-venue-text  plan-input-label">
                            {t('specific_actions.add_venue')}
                          </label>
                        </CustomTooltip>
                      </div>
                    )}

                    <div className="search-bar-wrapper">
                      <Grid.Column
                        mobile={16}
                        tablet={8}
                        computer={4}
                        className="extra-padding"
                      >
                        {userContractorVenuePartnerData.search ? (
                          <Search
                            className="search-field-custom search-wrapper"
                            loading={venueLoading}
                            onResultSelect={(e, obj) =>
                              this.handleResultSelect(e, obj, 'venue')
                            }
                            onSearchChange={debounce(
                              (e, obj) =>
                                this.handleSearchChange(
                                  e,
                                  obj,
                                  'venue',
                                  userContractorVenuePartnerData.organisationId
                                ),
                              500,
                              {
                                leading: true,
                              }
                            )}
                            results={venueResults}
                            value={venueValue}
                            resultRenderer={({ name }) => <>{name}</>}
                            placeholder={t(
                              'activity.activity_plan.activity_input.search_for_existing_venues'
                            )}
                            disabled={getPageDisable(
                              activity.currentActivity,
                              auth.user,
                              currentState,
                              actual
                            )}
                            // {...this.props}
                          />
                        ) : (
                          <div></div>
                        )}
                      </Grid.Column>
                      <VenueCreate
                        {...this.props}
                        projectId={activity.currentActivity.id}
                        userVenueData={userContractorVenuePartnerData}
                      />
                    </div>
                  </Segment>
                </div>
              </Grid.Column>
            </Grid.Row>
            {this.renderVenueCard(userContractorVenuePartnerData)}
            <Grid.Row>
              <Grid.Column //contractor info starts here
                mobile={16}
                tablet={16}
                computer={16}
              >
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    <Label className="contact-name">
                      {t('common.contractor')}
                    </Label>
                  </Segment>
                </div>
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    {auth.user && auth.user.role === 'guest' ? null : (
                      <div className="venue-label-div">
                        <CustomTooltip
                          state={get(auth, 'user.options.tips')}
                          contentObject={
                            actual
                              ? {
                                  data: helpTips,
                                  key: '135',
                                }
                              : {
                                  data: helpTips,
                                  key: '127',
                                }
                          }
                          position="top left"
                        >
                          <label className="add-contact-name plan-input-label">
                            {t('specific_actions.add_contractor')}
                          </label>
                        </CustomTooltip>
                      </div>
                    )}
                    <div className="search-bar-wrapper">
                      {/* {
                         auth.user &&
                        auth.user.role === 'guest' &&
                        !checkGuestCollaborator(activity, auth) ? (
                          <Search
                            className="search-field-custom search-wrapper"
                            loading={contractorGuestLoading}
                            onResultSelect={(e, obj) =>
                              this.handleResultSelect(e, obj, 'contractor')
                            }
                            onSearchChange={debounce(
                              (e, obj) =>
                                this.handleGuestSearch(e, obj, 'contractor'),
                              500,
                              {
                                leading: true,
                              }
                            )}
                            results={this.state.guestUserContractorsList}
                            value={this.state.guestUserValue}
                            placeholder="Search for existing contractors in the guest user"
                            resultRenderer={({
                              firstName,
                              secondName,
                              companyName,
                            }) => (
                              <div className="contractor-search-results-c">
                                <label className="company">
                                  <b>{companyName}</b>
                                </label>
                                <div>
                                  <p className="group">
                                    {firstName} {secondName}
                                  </p>
                                </div>
                              </div>
                            )}
                            disabled={getPageDisable(
                              activity.currentActivity,
                              auth.user,
                              currentState,
                              actual
                            )}
                          />
                        ) : (
                        }
                        */}
                      {userContractorVenuePartnerData.search ? (
                        <Search
                          className="search-field-custom search-wrapper"
                          loading={contractorLoading}
                          onResultSelect={(e, obj) =>
                            this.handleResultSelect(e, obj, 'contractor')
                          }
                          onSearchChange={debounce(
                            (e, obj) =>
                              this.handleSearchChange(
                                e,
                                obj,
                                'contractor',
                                userContractorVenuePartnerData.organisationId
                              ),
                            500,
                            {
                              leading: true,
                            }
                          )}
                          results={contractorResults}
                          value={contractorValue}
                          placeholder={t(
                            'activity.activity_plan.activity_input.search_for_existing_contractors'
                          )}
                          resultRenderer={({
                            firstName,
                            secondName,
                            companyName,
                          }) => (
                            <div className="contact-search-results-c">
                              <label className="company">
                                <b>{companyName}</b>
                              </label>
                              <div>
                                <p className="group">
                                  {firstName} {secondName}
                                </p>
                              </div>
                            </div>
                          )}
                          disabled={getPageDisable(
                            activity.currentActivity,
                            auth.user,
                            currentState,
                            actual
                          )}
                        />
                      ) : (
                        <div></div>
                      )}
                      {/* )  } */}
                      <>
                        <ContractorCreate
                          {...this.props}
                          projectId={activity.currentActivity.id}
                          userContractorData={userContractorVenuePartnerData}
                        />
                      </>
                    </div>
                  </Segment>
                </div>
              </Grid.Column>

              {/* contractor data table */}
            </Grid.Row>{' '}
          </Grid>
          <ContractorViewWithTranslation
            {...this.props}
            userContractorData={userContractorVenuePartnerData}
          />
          <Grid>
            <Grid.Row>
              <Grid.Column //partner info starts here
                mobile={16}
                tablet={16}
                computer={16}
              >
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    <Label className="contact-name">
                      {t('activity.activity_plan.activity_input.partner')}
                    </Label>
                    {partnersHelpKey && (
                      <div className="field-help-text">
                        {t(partnersHelpKey)}
                      </div>
                    )}
                    {auth.user && auth.user.role === 'guest' ? null : (
                      <div className="venue-label-div">
                        <CustomTooltip
                          state={get(auth, 'user.options.tips')}
                          content={t('specific_actions.add_partner')}
                          position="top left"
                          contentObject={{
                            data: helpTips,
                            key: '5001',
                          }}
                        >
                          <label className="add-contact-name plan-input-label">
                            {t('specific_actions.add_partner')}
                          </label>
                        </CustomTooltip>
                      </div>
                    )}
                    <div className="search-bar-wrapper">
                      {userContractorVenuePartnerData.search ? (
                        <Search
                          className="search-field-custom search-wrapper"
                          loading={partnerLoading}
                          onResultSelect={(e, obj) => {
                            this.setState(
                              { selectedPartner: obj.result },
                              () => {
                                this.handlePartnerResultSelect(
                                  e,
                                  obj,
                                  'partner'
                                );
                              }
                            );
                          }}
                          onSearchChange={debounce(
                            (e, obj) =>
                              this.handlePartnerSearchChange(
                                e,
                                obj,
                                userContractorVenuePartnerData.organisationId
                              ),
                            500,
                            {
                              leading: true,
                            }
                          )}
                          results={partnerResults}
                          value={partnerValue}
                          placeholder={t(
                            'activity.activity_plan.activity_input.search_for_existing_partners'
                          )}
                          resultRenderer={({
                            firstName,
                            secondName,
                            organisationName,
                          }) => (
                            <div className="contact-search-results-c">
                              <label className="company">
                                <b>{organisationName}</b>
                              </label>
                              <div>
                                <p className="group">
                                  {firstName} {secondName}
                                </p>
                              </div>
                            </div>
                          )}
                          disabled={getPageDisable(
                            activity.currentActivity,
                            auth.user,
                            currentState,
                            actual
                          )}
                        />
                      ) : (
                        <div></div>
                      )}
                      {/* {auth.user && auth.user.role === 'guest' ? null : ( */}
                      <>
                        <PartnerCreateFromActivity
                          {...this.props}
                          userPartnerData={userContractorVenuePartnerData}
                          projectId={activity.currentActivity.id}
                        />
                        <PartnerUpdateFromActivity
                          selectedPartner={selectedPartner}
                          userPartnerData={userContractorVenuePartnerData}
                          projectId={activity.currentActivity.id}
                          modal={addPartnerModal}
                          setModal={(value) => {
                            this.setState({ addPartnerModal: value });
                          }}
                          {...this.props}
                        />
                      </>
                      {/* )} */}
                    </div>
                  </Segment>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {/* Partner data table */}
          <PartnerViewWithTranslation {...this.props} />
          {/* TAK-2086: Other expenditure — last on the card, after the venue,
              contractor and partner amounts it no longer includes */}
          <Divider section />
          <Grid columns={2} stackable>
            <Grid.Row className="inputs-row">
              <Grid.Column
                mobile={16}
                tablet={16}
                computer={8}
                className="date-padding extra-padding date-input-row"
              >
                <div className="disabled-padding">
                  <Segment
                    disabled={getPageDisable(
                      activity.currentActivity,
                      auth.user,
                      currentState,
                      actual
                    )}
                  >
                    {/* TAK-2086b: a section heading like Venue, Contractor
                        and Partner — later the organisation's own
                        expenditure items — so the field itself only needs
                        Projected / Actual */}
                    <Label className="contact-name">
                      {t(
                        'activity.activity_plan.activity_input.other_expenditure'
                      )}
                    </Label>
                    <div className="expenditure-div">
                      <Label className="plan-input-label">
                        {actual ? t('common.actual') : t('common.projected')}
                      </Label>
                      <div className="expenditure-inline-row">
                        <InputGroup className="icon-inputs-style-custom">
                          <InputGroupAddon addonType="prepend">
                            <Icon
                              circular
                              inverted
                              name={get(
                                activity.currentActivity,
                                'currencyType.iconName',
                                'dollar sign'
                              )}
                              color="grey"
                            />
                          </InputGroupAddon>
                          <Input
                            className={
                              expenditureError
                                ? 'expenditure-input-err expenditure-input-custom '
                                : 'expenditure-input expenditure-input-custom '
                            }
                            disabled={noExpenditure}
                            onChange={(e, data) =>
                              this.onChange(e.target.value, data, 'expenditure')
                            }
                            onFocus={(e, data) =>
                              this.onFocus(e.target.value, data, 'expenditure')
                            }
                            onBlur={() => this.handleBlur('expenditure')}
                            value={expenditure}
                          />
                        </InputGroup>
                        <div className="no-expenditure-check">
                          <input
                            type="checkbox"
                            id="noExpenditure"
                            checked={noExpenditure}
                            onChange={(e) =>
                              this.handleNoExpenditureChange(e.target.checked)
                            }
                          />
                          <label htmlFor="noExpenditure">
                            {t(
                              'activity.activity_plan.activity_input.no_reportable_expenditure'
                            )}
                          </label>
                        </div>
                      </div>
                      {actual && (
                        <label className="projected-value">
                          {t(
                            'activity.activity_plan.activity_input.projected_amount'
                          )}{' '}
                          {thousands(activity.currentActivity.projectedCost) ||
                            '0.00'}
                        </label>
                      )}
                      <div
                        className={
                          expenditureError
                            ? 'error-msg-div'
                            : 'error-msg-hidden'
                        }
                      >
                        {expenditureError}
                      </div>
                    </div>
                  </Segment>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.authentication,
    organization: state.organization,
    extra: state.extra,
    user: state.authentication.user,
    activity: state.activity,
    helpTips: state.extra.activityHelpTips,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getOrgVenues,
      getOrgVenuesTypes,
      getVenueTypes,
      getOccupationTypes,
      getOccupation,
      getOrgContractors,
      assignProjectVenue,
      assignProjectContractor,
      updateProjectInputs,
      setActivityState,
      createOrgContractor,
      updateOrgContractor,
      createOrgVenues,
      updateOrgVenues,
      deleteProjectVenue,
      updateProjectVenueCost,
      deleteProjectContractor,
      updateProjectContractorCost,
      deleteProjectPartner,
      updateProjectPartner,
      putActivity,
      getOrgPartnersByKeywords,
      assignProjectPartner,
      getGuestContractors,
      getGuestVenues,
      addActivityMember,
    },
    dispatch
  );
};

ActivityInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ActivityInput));
